import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@mantine/core';
import { IconCircleCheck, IconClock, IconLoader, IconProgress, IconX } from '@tabler/icons-react';
import { dealStatusView } from '@/lib/dealStatus';
import type { BargainStatus } from '@/types/deals';

interface DealStatusBadgeProps {
  readonly status?: BargainStatus;
}

// Статус сделки бейджем: иконка + цвет + текст (никогда только цвет — §9).
const ICONS: Record<BargainStatus, ReactNode> = {
  IN_PROGRESS: <IconProgress size={14} />,
  WAIT_BPMN: <IconLoader size={14} />,
  CLOSED: <IconCircleCheck size={14} />,
  CANCELED: <IconX size={14} />,
};

export default function DealStatusBadge({ status }: DealStatusBadgeProps) {
  const { t } = useTranslation();
  const view = dealStatusView(status);
  const icon = status ? ICONS[status] : <IconClock size={14} />;
  return (
    <Badge variant="light" color={view.color} tt="none" fw={600} radius="sm" leftSection={icon}>
      {t(view.labelKey)}
    </Badge>
  );
}
